import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.25 4.08333H5.54167C3.60867 4.08333 2.04167 5.65034 2.04167 7.58333C2.04167 9.51633 3.60867 11.0833 5.54167 11.0833H9.33333",
		stroke: "currentColor",
		strokeWidth: 1.17,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.91667 1.75L12.25 4.08333L9.91667 6.41667",
		stroke: "currentColor",
		strokeWidth: 1.17,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgRedo;
